import { AncestorProject, AlmanacFile as File, MinimalFile } from 'types'

import { FolderRow } from '../FolderRow/FolderRow'
import { ArticleRow } from '../ArticleRow/ArticleRow'

interface FolderRowProps {
  folderItem: File
  nestedLevel: number
  selectedFiles: MinimalFile[]
  selectedFolder: AncestorProject | null
  setSelectedFolder: (folder: AncestorProject | null) => void
  setTopLevelFolder: (folder: AncestorProject | null) => void
  workspaceId: number
  openSelectedFolder?: (folder: File | null) => void
  disabled?: boolean
  hideTooltips?: boolean
}

export const FolderItem = ({ folderItem, ...props }: FolderRowProps) => {
  return folderItem.type === 'folder' ? (
    <FolderRow folder={folderItem} {...props} />
  ) : (
    <ArticleRow article={folderItem} nestedLevel={props.nestedLevel} />
  )
}
